import en from './messages/en';
import uk from './messages/uk';

export type MessageKey = keyof typeof en;

export const locales = {
  en,
  uk,
} as const;

export type Locale = keyof typeof locales;

export const defaultLocale: Locale = 'en';

export function isLocale(value: string | null | undefined): value is Locale {
  return value === 'en' || value === 'uk';
}
